import React from 'react';
import PropTypes from 'prop-types';
import Icon from '@components/UI/Icon';
import css from '@utils/css';

const AnchorDropdown = ({ data }) => {
    return (
        <nav className={ css(`
        flex-col w-fit justify-self-end hidden pt-8 pr-6 1024:flex 1280:pr-14
        `) }>
            <div className='sticky top-6 flex flex-col gap-y-9'>
                { data.map(({ title, data }) => (
                    <details open className='group' key={ title }>
                        <summary className='list-none desktop-subtitle flex items-center gap-x-2 mb-4 whitespace-nowrap'>
                            { title }
                            <Icon className='group-open:rotate-0 rotate-180' size={ 14 } color={ ['neutral-700'] } name='chevron-down'/>
                        </summary>
                        <ul className='gap-y-4 flex flex-col desktop-body-3 text-neutral-700'>
                            { data.map(data =>
                                <a
                                    href={ data.href }
                                    key={ data.title }
                                    className='decoration-dotted underline underline-offset-4'
                                >
                                    { data.title }
                                </a>
                            ) }
                        </ul>
                    </details>
                )) }
            </div>
        </nav>
    );
};

AnchorDropdown.propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({
        title: PropTypes.string,
        data: PropTypes.arrayOf(PropTypes.shape({
            title: PropTypes.string,
            href: PropTypes.string
        }))
    })).isRequired
};

export default AnchorDropdown;
